#import "./TrainingComplianceCellFields.graphql"

query GetTrainingCourseProgress($courseId: ID!) {
  trainingCourseProgress(courseId: $courseId) {
    employeeId
    name
    email
    team {
      id
      name
    }
    inScope
    completeCount
    cells {
      ...TrainingComplianceCellFields
    }
  }
}
